import * as React from "react";
const SvgFiRrRingsWedding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-rings-wedding_svg__a)">
      <path d="M16 8a7.97 7.97 0 0 0-5.974 2.7 7 7 0 0 0-1.495-.524l1.37-2.729a1 1 0 0 0-.044-.97A3.4 3.4 0 0 0 7 5a3.4 3.4 0 0 0-2.852 1.476 1 1 0 0 0-.043.971l1.364 2.727a7 7 0 1 0 5.866 12.312A8 8 0 1 0 16 8m-4.766 11.63a5.95 5.95 0 0 1-.678-6.137 4.946 4.946 0 0 1 .678 6.137M2 17a4.987 4.987 0 0 1 6.88-4.627 7.96 7.96 0 0 0 .965 8.73A4.99 4.99 0 0 1 2 17m14 5a5.96 5.96 0 0 1-3.278-.98 6.964 6.964 0 0 0-1.022-9.194A6 6 0 1 1 16 22M10.554 4.895a1 1 0 0 0 1.346-.448l1-2a1 1 0 0 0-1.79-.894l-1 2a1 1 0 0 0 .444 1.342M2.105 4.447A1.003 1.003 0 0 0 3.9 3.553l-1-2a1 1 0 1 0-1.79.894zM7 4a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1" />
    </g>
    <defs>
      <clipPath id="fi-rr-rings-wedding_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRingsWedding;
